import { Box, Stack } from "@mui/material";
import {
  SEO,
  Typography,
  DataGrid,
  FilterGrid,
  FilterGridItem,
  TextField,
  Select,
  PlusIcon,
  Button,
  AutocompleteAsync,
  HeaderBar,
} from "components";
import { Paths, Permissions } from "configs";
import usePermission from "hooks/usePermission";
import { Link } from "react-router-dom";
import { RoleStatusOptions } from "services";
import { i18n } from "translations";

import { useHook } from "./hooks";

const IndexPage = () => {
  const { dataTable, filter } = useHook();
  const { canAccess } = usePermission();
  return (
    <>
      <SEO title={i18n.t("roles")} />
      <Stack width="100%">
        <HeaderBar>
          <Stack
            direction={["column", "row"]}
            justifyContent="space-between"
            width="100%"
          >
            <Typography
              fontWeight={600}
              color="grey.900"
              type="DisplaySM"
              variant="h1"
            >
              {i18n.t("roles")}
            </Typography>
            {canAccess(Permissions.Role.Create) && (
              <Button
                component={Link}
                to={Paths.RolesCreate}
                size="md"
                variant="contained"
                startIcon={<PlusIcon />}
              >
                {i18n.t("createRole")}
              </Button>
            )}
          </Stack>
        </HeaderBar>
        <Stack marginTop={8}>
          <FilterGrid filter={filter.state} defaultOpen>
            <FilterGridItem>
              <AutocompleteAsync
                label={i18n.t("application")}
                placeholder={i18n.t("searchByApplication")}
                model="application"
                keySubLabel="code"
                keyValue="id"
                keyLabel="name"
                onChange={(value) =>
                  filter.setFilters({ applicationId: value })
                }
                defaultFirstValue
                defaultValue={{
                  label: String(filter.state.applicationId),
                  value: String(filter.state.applicationId),
                }}
                filterLocal
                required
              />
            </FilterGridItem>
            <FilterGridItem>
              <AutocompleteAsync
                label={i18n.t("organization")}
                placeholder={i18n.t("organization")}
                model="organization"
                keyValue="id"
                keyLabel="name"
                onChange={(value) =>
                  filter.setFilters({ organizationId: value })
                }
              />
            </FilterGridItem>
            <FilterGridItem>
              <TextField
                label={i18n.t("keyword")}
                placeholder={i18n.t("searchByName")}
                defaultValue={filter.state.name}
                onChange={(name: string) => filter.debounceSetFilters({ name })}
              />
            </FilterGridItem>
            <FilterGridItem>
              <TextField
                label={i18n.t("code")}
                placeholder={i18n.t("searchByCode")}
                defaultValue={filter.state.code}
                onChange={(code: string) => filter.debounceSetFilters({ code })}
              />
            </FilterGridItem>
            <FilterGridItem>
              <Select
                label={i18n.t("status")}
                options={RoleStatusOptions}
                placeholder={i18n.t("selectStatus")}
                value={filter.state.status}
                onChange={(status) => filter.setFilters({ status })}
              />
            </FilterGridItem>
          </FilterGrid>
        </Stack>
        <Box width="100%" mt="32px">
          <DataGrid
            autoHeight
            loading={dataTable.isFetching}
            columns={dataTable.columns}
            rows={dataTable.rows}
            rowCount={dataTable.total}
            pagination
            paginationModel={{
              page: +dataTable.page - 1,
              pageSize: +dataTable.limit,
            }}
            onPaginationModelChange={({ page, pageSize }) => {
              filter.setFilters({ page: page + 1, limit: pageSize });
            }}
            paginationMode="server"
            disableRowSelectionOnClick
            initialState={{
              pinnedColumns: { right: ["actions"] },
            }}
          />
        </Box>
      </Stack>
    </>
  );
};

export default IndexPage;
